import classNames from "classnames";
import { InfoItem } from "components/DesignSystem/InfoItem/InfoItem";
import { SENSITIVE_DATA_MASKED_VALUE } from "constants/sensitiveData";
import { SensitiveDataCopyButton } from "components/SensitiveData/SensitiveDataCopyButton";
import { SensitiveDataFileList } from "components/SensitiveData/SensitiveDataFileList";
import { SensitiveDataFormField } from "types/Models/sensitiveData";
import { getSensitiveDataBooleanLabel } from "util/getSensitiveDataBooleanLabel";
import { getSensitiveDataFieldLabel } from "util/getSensitiveDataFieldLabel";

const MULTI_FILE_INPUT = "MULTI_FILE_INPUT";
const TEXTAREA = "TEXTAREA";
const BOOLEAN = "BOOLEAN";
const FULL_WIDTH_DATA_TYPES: SensitiveDataFormField["data_type"][] = [
  MULTI_FILE_INPUT,
  TEXTAREA,
  BOOLEAN,
];

export const SensitiveDataDetailField = ({
  field,
  formId,
}: {
  field: SensitiveDataFormField;
  formId: string;
}) => {
  const {
    uuid,
    key,
    value,
    value_display,
    data_type,
    is_encrypted,
    is_copyable,
  } = field;

  const label = getSensitiveDataFieldLabel(key);

  const isGated = Boolean(field.depends_on) && !field.is_derived;
  const isFullWidth = FULL_WIDTH_DATA_TYPES.includes(data_type) || isGated;

  const className = classNames("t-min-w-0", {
    "t-col-span-2": isFullWidth,
  });

  if (data_type === MULTI_FILE_INPUT) {
    const fileIds = Array.isArray(value) ? value : [];

    return (
      <InfoItem
        label={label}
        valueClassName="t-text-body"
        className={className}
      >
        {fileIds.length > 0 ? <SensitiveDataFileList fileIds={fileIds} /> : "-"}
      </InfoItem>
    );
  }

  if (data_type === BOOLEAN) {
    return (
      <InfoItem
        label={label}
        valueClassName="t-text-body"
        className={className}
      >
        {getSensitiveDataBooleanLabel(value)}
      </InfoItem>
    );
  }

  const storedDisplay = is_encrypted || value_display ? value_display : value;
  const hasValue = typeof storedDisplay === "string" && Boolean(storedDisplay);
  const displayValue = is_encrypted
    ? SENSITIVE_DATA_MASKED_VALUE
    : storedDisplay;
  const canCopy = hasValue && is_copyable;

  return (
    <InfoItem label={label} valueClassName="t-text-body" className={className}>
      <span className="t-flex t-min-w-0 t-items-start t-gap-1">
        <span className="t-min-w-0 t-break-words">
          {hasValue ? displayValue : "-"}
        </span>
        {canCopy && (
          <span className="t-shrink-0">
            <SensitiveDataCopyButton
              formId={formId}
              attributeId={uuid}
              value={is_encrypted ? undefined : storedDisplay}
            />
          </span>
        )}
      </span>
    </InfoItem>
  );
};
